import { CLOUD, loggedIn } from './cloud/api.js';
import { t } from './i18n/index.js';
import { S, persist } from './state.js';
import { RT, esc, nav, render } from './ui.js';
import { FLAGS, LANG_NAMES } from './flags.js';
import { applyTheme, updateLangButtons } from './theme.js';
import { openStory } from './story.js';

/* First start of a brand-new account: the feather draws itself, three questions
   (name, subjects, rate), then the overview scrolls to "Erste Schritte".
   Accounts that already have data never see it. */
const FEATHER='M352 112c-72 8-136 56-168 120-20.8 41.6-28.8 88-31.2 132.8l-4.8 39.2c-.8 7.2 7.2 12.8 13.6 8.8l33.6-20.8C240 368 284 344 316 308c44-48 56-128 36-196z';
/* "Just me" or "my tutoring school": the sales page's Team button pre-selects the school */
let KIND=null;
const intent=()=>{try{return localStorage.getItem('plume.intent')}catch(e){return null}};

export function maybeWelcome(){
  try{
    if(!loggedIn()||document.querySelector('.welcome'))return;
    const st=S.settings;st.dismissed=st.dismissed||{};
    if(st.dismissed.welcome)return;
    const c=CLOUD.ctx;if(c&&c.role&&c.role!=='owner'){st.dismissed.welcome=true;return}
    if(S.students.length||S.sessions.length||S.recs.length||S.invoices.length){st.dismissed.welcome=true;persist();return}
    show();
  }catch(e){console.warn('welcome',e)}
}
function done(root,saved){
  S.settings.dismissed=S.settings.dismissed||{};S.settings.dismissed.welcome=true;persist();
  root.classList.add('out');
  setTimeout(()=>{root.remove();if(RT.v!=='home')nav('home');else render();
    // then the story: how Plume works, in a minute of small animations
    setTimeout(()=>openStory({school:!!S.settings.school,onDone:go=>{
      if(!go){highlightSteps();return}
      if(S.settings.school)import('./views/team.js').then(m=>m.openInvite?m.openInvite():nav('team'));
      else import('./views/students.js').then(m=>m.openStudentEditor());
    }}),380);
  },420);
}
function highlightSteps(){
  setTimeout(()=>{
    const card=document.querySelector('.onboard');if(!card)return;
    card.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    card.classList.add('glow');setTimeout(()=>card.classList.remove('glow'),2600);
  },120);
}
function show(again){
  const st=S.settings;
  const subs=t('wl.subjectList').split('|');
  const name=st.teacher||(CLOUD.auth&&CLOUD.auth.name)||'';
  const cur=st.currency==='EUR'?'€':st.currency;
  const kind=KIND||(intent()==='school'?'school':'solo');
  const root=document.createElement('div');
  root.className='welcome'+(again?' again':'');root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');root.setAttribute('aria-labelledby','wl-h');
  root.innerHTML=`<div class="wl-stage">
    <div class="wl-mark" aria-hidden="true">
      <svg viewBox="96 96 320 340"><path class="wl-feather" d="${FEATHER}"/><path class="wl-line" d="M160 392 336 160"/></svg>
      <div class="wl-word">plume<i>.</i></div>
    </div>
    <form class="wl-card" novalidate>
      <h1 id="wl-h">${t('wl.hello')}</h1>
      <p class="wl-lead">${t('wl.lead')}</p>
      <div class="wl-prefs">
        <div><div class="wl-q">${t('wl.lang')}</div><div class="wl-langs">${['de','en','fr'].map(l=>`<button type="button" class="wl-lang" data-l="${l}" aria-pressed="${st.lang===l}"><span class="flag">${FLAGS[l]}</span>${LANG_NAMES[l]}</button>`).join('')}</div></div>
        <div><div class="wl-q">${t('wl.theme')}</div><div class="seg wl-theme">${['light','dark','auto'].map(x=>`<button type="button" data-th="${x}" class="${st.theme===x?'on':''}">${t('set.t.'+x)}</button>`).join('')}</div></div>
      </div>
      <div class="wl-q" id="wl-kq">${t('wl.who')}</div>
      <div class="seg wl-kind" role="group" aria-labelledby="wl-kq">${['solo','school'].map(k=>`<button type="button" data-k="${k}" class="${kind===k?'on':''}" aria-pressed="${kind===k}">${t('wl.'+k)}</button>`).join('')}</div>
      <div class="wl-schoolname"${kind==='school'?'':' hidden'}><label class="wl-q" for="wl-school">${t('wl.schoolName')}</label><input class="input" id="wl-school" autocomplete="organization" placeholder="${esc(t('wl.schoolPh'))}" value="${esc(st.biz||'')}"></div>
      <label class="wl-q" for="wl-name">${t('wl.name')}</label>
      <input class="input" id="wl-name" autocomplete="name" placeholder="${esc(t('wl.namePh'))}" value="${esc(name)}">
      <div class="wl-q" id="wl-sq">${t('wl.subjects')}</div>
      <div class="wl-chips" role="group" aria-labelledby="wl-sq">${subs.map(x=>`<button type="button" class="wl-chip" aria-pressed="false" data-s="${esc(x)}">${esc(x)}</button>`).join('')}</div>
      <input class="input" id="wl-other" placeholder="${esc(t('wl.other'))}">
      <label class="wl-q" for="wl-rate">${t('wl.rate')}</label>
      <div class="wl-rate"><input class="input" id="wl-rate" type="number" min="0" step="0.5" inputmode="decimal" value="${esc(st.defRate||30)}"><span>${esc(cur)} / ${t('c.h')}</span></div>
      <div class="wl-foot"><button type="button" class="btn ghost" data-wl="skip">${t('wl.skip')}</button><button type="submit" class="btn primary big">${t('wl.go')}</button></div>
    </form>
  </div>`;
  document.body.appendChild(root);
  root.querySelectorAll('.wl-lang').forEach(b=>b.onclick=()=>{
    const keep={name:root.querySelector('#wl-name').value,rate:root.querySelector('#wl-rate').value,school:root.querySelector('#wl-school').value};
    S.settings.lang=b.dataset.l;persist();updateLangButtons();root.remove();show(true);
    root.ownerDocument.querySelector('#wl-name').value=keep.name;root.ownerDocument.querySelector('#wl-rate').value=keep.rate;root.ownerDocument.querySelector('#wl-school').value=keep.school;
  });
  root.querySelectorAll('[data-th]').forEach(b=>b.onclick=()=>{
    S.settings.theme=b.dataset.th;persist();applyTheme();
    root.querySelectorAll('[data-th]').forEach(x=>x.classList.toggle('on',x===b));
  });
  root.querySelectorAll('[data-k]').forEach(b=>b.onclick=()=>{
    KIND=b.dataset.k;root.querySelectorAll('[data-k]').forEach(x=>{x.classList.toggle('on',x===b);x.setAttribute('aria-pressed',x===b)});
    const box=root.querySelector('.wl-schoolname');box.hidden=KIND!=='school';if(KIND==='school')root.querySelector('#wl-school').focus();
  });
  root.querySelectorAll('.wl-chip').forEach(b=>b.onclick=()=>b.setAttribute('aria-pressed',b.getAttribute('aria-pressed')==='true'?'false':'true'));
  root.querySelector('[data-wl=skip]').onclick=()=>done(root,false);
  root.querySelector('form').onsubmit=e=>{
    e.preventDefault();
    const n=root.querySelector('#wl-name').value.trim();if(n)S.settings.teacher=n;
    const picked=[...root.querySelectorAll('.wl-chip[aria-pressed=true]')].map(b=>b.dataset.s);
    const other=root.querySelector('#wl-other').value.split(',').map(x=>x.trim()).filter(Boolean);
    const all=[...new Set([...picked,...other])];if(all.length)S.settings.subjects=all;
    const r=parseFloat(root.querySelector('#wl-rate').value);if(r>0)S.settings.defRate=r;
    if((KIND||(intent()==='school'?'school':'solo'))==='school'){S.settings.school=true;const sn=root.querySelector('#wl-school').value.trim();if(sn)S.settings.biz=sn}
    try{localStorage.removeItem('plume.intent')}catch(e){}
    done(root,true);
  };
  setTimeout(()=>{const f=root.querySelector('#wl-name');if(f&&matchMedia('(min-width:761px)').matches)f.focus()},1700);
}
